import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'formik-semantic-ui';
import { EUserGroup, IUser } from '@relab/alstom-ptw-shared';

import { appState } from '../redux/selectors';
import { usersAction } from '../redux/actions';
import { RootState } from '../redux/types';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

interface UserSelectComponentProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  projectId?: string;
  group?: EUserGroup;
  users: IUser[];
  usersAction: typeof usersAction;
  multiple?: boolean;
  name: string;
  value?: any;
  onBlur?: any;
}

class PUserSelectComponent extends Component<UserSelectComponentProps> {
  componentDidMount(): void {
    this.props.usersAction();
  }

  render() {
    const { users = [], multiple = false, name, value, t } = this.props;

    return (
      <Dropdown
        inputProps={{
          placeholder: t('Select user'),
          fluid: true,
          loading: users.length === 0,
          multiple,
          search: true,
          selection: true,
          value,
        }}
        name={name}
        options={users.map((user) => ({
          key: user._id,
          text: user.name,
          name,
          value: user._id,
        }))}
      />
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: Partial<UserSelectComponentProps>) => {
  const users = !!ownProps.projectId
    ? appState(state)
        .project.assignees.filter((assignee) => assignee.group === ownProps.group)
        .map((assignee) => assignee.user as IUser)
    : appState(state).users;

  if (!!users) {
    users.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  return {
    users,
  };
};

export const UserSelectComponent = connect(mapStateToProps, { usersAction })(withTranslation()(PUserSelectComponent));
